import { IPageState } from '../../types/page';

export const initialState: IPageState = {
  deviceType: 'desktop' as const,
  referrer: '',
  queryParams: {},
  platform: 'desktop',
};

export function pageReducer(state = initialState) {
  return state;
}
